export default function summarizeAssignments(list) {
  const items = list || [];
  const activityIds = new Set();
  const studentIds = new Set();
  let previouslyHadResultCount = 0;

  items.forEach((item) => {
    if (item.activityId !== undefined && item.activityId !== null) {
      activityIds.add(item.activityId);
    }
    if (item.encryptedUserProfileId) {
      studentIds.add(item.encryptedUserProfileId);
    }
    if (item.result?.score !== undefined && item.result?.score !== null) {
      previouslyHadResultCount += 1;
    }
  });

  return {
    activityCount: activityIds.size || items.length,
    studentCount: studentIds.size,
    previouslyHadResult: previouslyHadResultCount > 0,
    previouslyHadResultCount
  };
}



// WEBPACK FOOTER //
// ./analytics/tracking/assignment-summary.js